import { render, staticRenderFns } from "./CustomersForm.vue?vue&type=template&id=6f5e69c0&scoped=true"
import script from "./CustomersForm.vue?vue&type=script&lang=js"
export * from "./CustomersForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5e69c0",
  null
  
)

export default component.exports